export function getdata() {
    var obj = {
        headlist: [
            {
                name: "进项发票"
            },
            {
                name: "即征即退明细"
            }
        ]
    }
    return obj
}
